import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, takeUntil, filter } from 'rxjs';
import { UserPreferencesService } from 'app/core/user/user-preferences.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';


@Component({
    selector: 'user-favorites-toggle',
    template: `
        <button
            mat-icon-button
            (click)="toggleFavorite()"
            [color]="isFavorite ? 'primary' : ''"
            [matTooltip]="isFavorite ? 'Remove from favorites' : 'Add to favorites'">
            <mat-icon [svgIcon]="isFavorite ? 'heroicons_solid:star' : 'heroicons_outline:star'"></mat-icon>
        </button>
    `,
    encapsulation: ViewEncapsulation.None,
    imports: [MatButtonModule, MatIconModule, MatTooltipModule]
})
export class UserFavoritesToggleComponent implements OnInit, OnDestroy {
    isFavorite: boolean = false;
    private _currentUrl: string = '';
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _router: Router,
        private _userPreferencesService: UserPreferencesService
    ) { }

    ngOnInit(): void {
        this._currentUrl = this._router.url;

        // Subscribe to routing events
        this._router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntil(this._unsubscribeAll)
        ).subscribe((event: NavigationEnd) => {
            this._currentUrl = event.urlAfterRedirects; // Use urlAfterRedirects
            this._checkIfFavorite();
            this._userPreferencesService.addToRecents(this._currentUrl).subscribe();
        });

        // Subscribe to preferences changes
        this._userPreferencesService.preferences$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this._checkIfFavorite();
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    private _checkIfFavorite(): void {
        this._userPreferencesService.preferences$.pipe(takeUntil(this._unsubscribeAll)).subscribe(prefs => {
            if (prefs && prefs.favoritos) {
                // Remove query params for comparison if needed, but for now exact match
                // If using query params, URL might not match exactly.
                // let url = this._currentUrl.split('?')[0]; 
                // For now, strict match.
                this.isFavorite = prefs.favoritos.includes(this._currentUrl);
            }
        });
    }

    toggleFavorite(): void {
        this._userPreferencesService.toggleFavorite(this._currentUrl).subscribe();
    }
}
